module.exports = __webpack_public_path__ + "img/twitter.5be627a1.png";